















































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class SalesReportSummary extends Vue {
  @Prop({ required: true }) data!: any;

  formatCurrency(value: any) {
    return value || value === 0 ? "￥" + Number(value).toLocaleString() : "";
  }

  isNegative(value: any) {
    return Number(value) < 0;
  }
}
